import { Lock, BookBookmark } from "@phosphor-icons/react";

export const SPINES = ["#A84A32", "#7EA193", "#D1A33B", "#2E3B31", "#E8945A", "#8A6F9E", "#6B8CA8"];

const yearSpan = (items) => {
  const years = items.map((m) => (m.event_date || "").slice(0, 4)).filter((y) => /^\d{4}$/.test(y)).sort();
  if (!years.length) return null;
  return years[0] === years[years.length - 1] ? years[0] : `${years[0]} – ${years[years.length - 1]}`;
};

export const SeasonCover = ({ season, items, locked, isPro, index, onOpen, onUpgrade }) => {
  const span = yearSpan(items);
  return (
    <button data-testid={locked ? `unlock-season-${season.id}` : `season-cover-${season.id}`}
      onClick={locked && !items.length ? onUpgrade : onOpen}
      className={`drift-in group relative flex min-h-[150px] overflow-hidden rounded-r-xl rounded-l-sm border text-left transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-lg ${
        locked ? "border-dashed border-[#4A4540]/25 bg-[#F4EFE6]" : "border-[#4A4540]/10 bg-[#FFFCF6] shadow-sm"}`}
      style={{ animationDelay: `${index * 0.05}s` }}>
      {locked && (
        <span data-testid={`season-lock-${season.id}`} aria-label="Locked"
          className="absolute right-3 top-3 flex h-9 w-9 items-center justify-center rounded-full bg-[#2C2A28] text-white shadow-md">
          <Lock size={18} weight="fill" />
        </span>
      )}
      <span className="w-3 shrink-0" style={{ backgroundColor: locked ? "#CFC6B8" : SPINES[index % SPINES.length] }} />
      <span className="flex flex-1 flex-col p-5">
        <span className="flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] text-[#8A7F76]">
          {locked ? <Lock size={12} weight="fill" /> : <BookBookmark size={13} weight="duotone" />} {season.note}
        </span>
        <span className={`mt-2 font-serif text-2xl ${locked ? "text-[#8A7F76]" : "text-[#2C2A28]"}`}>{season.label}</span>
        <span className="mt-auto pt-4 text-sm text-[#8A7F76]" data-testid={`season-count-${season.id}`}>
          {locked && items.length > 0 ? (
            <span data-testid={`season-readonly-${season.id}`} className="font-medium text-[#8A5A2B]">{items.length} saved {items.length === 1 ? "memory" : "memories"} · view only</span>
          ) : locked ? (
            <span className="font-medium text-[#B08D57]">Included in Lifetime Access →</span>
          ) : (
            <>
              {items.length} {items.length === 1 ? "memory" : "memories"}
              {span && <span className="ml-2 text-[#B08D57]">· {span}</span>}
              {season.free && !isPro && <span data-testid="season-free-badge" className="ml-2 inline-block rounded-full bg-[#F2B24C] px-2 py-0.5 text-[10px] font-semibold text-[#5A3A10]">Free 10 day trial</span>}
              {season.free && !isPro && (
                <span data-testid="season-free-note" className="mt-2 block text-xs leading-relaxed text-[#8A5A2B]">
                  Includes one complimentary Memory Insight after five meaningful Childhood memory entries.
                </span>
              )}
            </>
          )}
        </span>
      </span>
    </button>
  );
};
